import { OnboardingCardList } from '../../../../../components/OnboardingCard';
import { Gapper } from '../../../../../ui/utils';
import { Title, Subtitle, Text, ListTitle, Wrapper } from './styles';
import CTAButton from '../../../../../ui/ctaButton';
import {
  StepCardSectionImage,
  TwoColumnLayoutCentered,
} from '../../../../../components/StepCardLayout/styles';
import HowWeWorkImage from '../../../../../assets/images/how_we_work.webp';
import { Box } from '@mui/material';

const HowWeWork = ({
  title,
  subtitle,
  description,
  listTitle,
  cards,
  responseTimeText,
  button = { text: '' },
  onButtonClick = () => {},
}) => {
  const handleButtonClick = () => {
    onButtonClick && onButtonClick();
  };

  return (
    <Wrapper gap={50}>
      <Box>
        <Gapper gap={14}>
          <Title>{title}</Title>
          <Subtitle>{subtitle}</Subtitle>
          <Text>{description}</Text>
        </Gapper>
      </Box>
      <Gapper gap={20}>
        <ListTitle>{listTitle}</ListTitle>
        <TwoColumnLayoutCentered>
          <Box>
            <Gapper gap={18}>
              <OnboardingCardList cards={cards} />
            </Gapper>
          </Box>
          <Box>
            <StepCardSectionImage
              src={HowWeWorkImage}
              alt="How we work step by step"
              // Journey has one fewer step now, so cap the image height to keep it
              // aligned with the shorter text column on this page.
              style={{ maxHeight: '750px' }}
            />
          </Box>
        </TwoColumnLayoutCentered>
      </Gapper>
      <Text dangerouslySetInnerHTML={{ __html: responseTimeText }} />
      <CTAButton text={button.text} onClick={handleButtonClick} />
    </Wrapper>
  );
};

export default HowWeWork;
